module.exports = __webpack_public_path__ + "img/home-reply.b7b7f733.png";